
































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { WorkbookEntryDto } from '@/models/dtos/workbookEntryDto'
import { ValidationObserver } from 'vee-validate'
import { BvModalEvent } from 'bootstrap-vue'
import { UserInfoDto } from '@/models/dtos/userInfoDto'
import { UserDto } from '@/models/dtos/userDto'
import { UserMixin } from '@/mixins/userMixin'
import { mixins } from 'vue-class-component'
import { GroupedWorkbookEntryDto } from '@/models/dtos/groupedWorkbookEntryDto'
import { AuthService as _authService } from '@/services/auth.service'
import { WorkbookService as _workbookService } from '@/services/workbook.service'
import { ProjectService as _projectService } from '@/services/project.service'
import { UserService as _userService } from '@/services/user.service'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

@Component({
  components: {
    DatePicker
  }
})
export default class WorkbookEntryModal extends mixins(UserMixin) {
  // Refs
  $refs!: {
    workbookEntryForm: InstanceType<typeof ValidationObserver>;
  }

  // Props
  @Prop({ type: Array, required: false }) projectUsers!: string[]
  @Prop({ type: Array, required: false }) availableUsers!: UserDto[]

  // Data
  private groupedWorkbookEntry: GroupedWorkbookEntryDto | null = null;
  private currentUser: UserInfoDto | null = null
  private projectId: string = ''
  private assaigned: string[] = []
  private users: UserDto[] = []
  private groupEntry: boolean = false

  // Methods
  private initWorkbookEntry(workbookEntry: WorkbookEntryDto | null) {
    if (workbookEntry) {
      this.groupedWorkbookEntry = {
        entry: { ...workbookEntry },
        users: [workbookEntry.accountId]
      }
    } else {
      this.groupedWorkbookEntry = {
        entry: {
          date: moment().format('YYYY-MM-DD'),
          endTime: '14:00',
          startTime: '06:00',
          message: '',
          project: {
            id: this.projectId
          }
        } as WorkbookEntryDto,
        users: [this.currentUser!.id]
      }
    }
  }

  private changeEntryMode() {
    if (this.groupedWorkbookEntry?.entry.isNote) {
      this.groupEntry = false
    }
  }

  private addUser(user: UserDto) {
    this.groupedWorkbookEntry!.users.push(user.id)
  }

  private removeUser(user: UserDto) {
    this.groupedWorkbookEntry!.users = this.groupedWorkbookEntry!.users.filter((uId: string) => uId !== user.id)
  }

  private groupEntryChange() {
    if (!this.groupEntry) {
      this.groupedWorkbookEntry!.users = this.groupedWorkbookEntry!.users.filter((userId: string) => userId === this.currentUser!.id)
    }
  }

  private async saveWorkbookEntry(bvModalEvt: BvModalEvent) {
    bvModalEvt.preventDefault()

    const today = new Date()
    const startTime = this.groupedWorkbookEntry!.entry.startTime.split(':').map(x => parseInt(x))
    const endTime = this.groupedWorkbookEntry!.entry.endTime.split(':').map(x => parseInt(x))

    if (today.setHours(startTime[0], startTime[1]) > today.setHours(endTime[0], endTime[1])) {
      this.$notify({
        group: 'notifications',
        title: 'Projekt',
        text: 'Godzina startu nie może być większa od godziny zakończenia!',
        type: 'error'
      })

      return
    }

    const isValid = await this.$refs.workbookEntryForm.validate()
    if (isValid) {
      this.$nextTick(async() => {
        const result = this.groupedWorkbookEntry!.entry.id
          ? await _workbookService.updateWorkbookEntry(this.groupedWorkbookEntry!.entry)
          : await _workbookService.addWorkbookEntry(this.groupedWorkbookEntry!)

        if (result.succeeded) {
          this.$emit('save')
          this.$root.$emit('worbook-entry-modal-saved')
          this.$bvModal.hide('worbook-entry-modal')
        }
      })
    }
  }

  // Getters
  private get notChoosen() {
    return this.assaigned.filter(aId => !this.groupedWorkbookEntry!.users.includes(aId))
  }

  // Lifecycle
  async mounted() {
    this.$root.$on('show-workbook-entry-modal', async(workbookEntry: WorkbookEntryDto | null, projectId: string) => {
      this.projectId = workbookEntry?.project.id || projectId

      this.availableUsers
        ? this.users = [...this.availableUsers]
        : this.users = await _userService.getUsers()

      this.projectUsers
        ? this.assaigned = [...this.projectUsers]
        : this.assaigned = (await _projectService.getProject(this.projectId)).assaignedUsers

      _authService.currentUser().subscribe(userInfo => {
        this.currentUser = userInfo
        this.groupEntry = false
        this.initWorkbookEntry(workbookEntry)
        this.$bvModal.show('worbook-entry-modal')
      })
    })
  }

  // Watchers
  @Watch('groupEntry')
  onGroupEntryChange(value: boolean) {
    if (!value) {
      this.groupedWorkbookEntry!.users = [this.currentUser!.id]
    }
  }
}
